export default __webpack_public_path__ + "static/media/Icon Button.6746fda8.svg";